import { put, call, select, takeEvery } from 'redux-saga/effects';
import { ActionTypes } from '../actions/actionTypes';
import { setAddWidgetNotification, saveWidgetsFailure, saveWidgetsSuccess, WidgetActions } from '../actions/widgetActions';
import { updateUserWidgets } from '../apis/userWidgets';
import { addWidget, deleteWidget, getReactGridLayoutArray, getWidgetsInCurrentState, updateWidget, getWindowWidthInCurrentState } from '../utilities/widgetHelper'
import { UserWidget } from '../constants/online.homepagegateway.api';
import { defaultWidgets } from '../constants/defaultWidgets';

export function* modifyWidgets(action: WidgetActions) {
    try {
        const widgets: UserWidget[] = yield select(getWidgetsInCurrentState);
        const windowWidth: number = yield select(getWindowWidthInCurrentState);

        let modifiedWidgets: UserWidget[] = [];
        if (action.type == ActionTypes.ADD_WIDGET) {
            modifiedWidgets = addWidget(widgets, action.payload, windowWidth);
        }
        else if (action.type == ActionTypes.UPDATE_WIDGET) {
            modifiedWidgets = updateWidget(widgets, action.payload);
        }
        else if (action.type == ActionTypes.DELETE_WIDGET) {
            modifiedWidgets = deleteWidget(widgets, action.payload);
        }
        else if (action.type == ActionTypes.RESET_WIDGETS) {
            yield put(saveWidgetsSuccess([], []));
            modifiedWidgets = defaultWidgets(windowWidth);
        }

        yield call(updateUserWidgets, {widgetData: modifiedWidgets});

        const gridLayout = getReactGridLayoutArray(modifiedWidgets);
        yield put(saveWidgetsSuccess(modifiedWidgets, gridLayout));
        if (action.type == ActionTypes.ADD_WIDGET){
            yield put(setAddWidgetNotification({name: action.payload.title, id: action.payload.id}));
        }
    }
    catch (error) {
        yield put(saveWidgetsFailure(error));
    }
}

export function* watchAddWidget() {
    yield takeEvery(ActionTypes.ADD_WIDGET, modifyWidgets);
}

export function* watchUpdateWidget() {
    yield takeEvery(ActionTypes.UPDATE_WIDGET, modifyWidgets);
}

export function* watchDeleteWidget() {
    yield takeEvery(ActionTypes.DELETE_WIDGET, modifyWidgets);
}

export function* watchResetWidgets() {
    yield takeEvery(ActionTypes.RESET_WIDGETS, modifyWidgets);
}